import { render, staticRenderFns } from "./RoleAccessDrawer.vue?vue&type=template&id=690441ec&scoped=true&"
import script from "./RoleAccessDrawer.vue?vue&type=script&lang=js&"
export * from "./RoleAccessDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RoleAccessDrawer.vue?vue&type=style&index=0&id=690441ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690441ec",
  null
  
)

export default component.exports